import React from 'react';
interface SkeletonChartProps {
  height?: string;
  className?: string;
}
const SkeletonChart: React.FC<SkeletonChartProps> = ({
  height = 'h-80',
  className = ''
}) => {
  return <div className={`rounded-lg border border-gray-200 bg-white shadow-sm animate-pulse ${className}`} data-id="element-682">
      <div className="px-6 py-4 border-b border-gray-200" data-id="element-683">
        <div className="h-6 bg-gray-200 rounded w-1/3" data-id="element-684"></div>
      </div>
      <div className={`p-6 ${height}`} data-id="element-685">
        <div className="flex flex-col h-full" data-id="element-686">
          <div className="flex justify-end mb-4" data-id="element-687">
            <div className="h-8 bg-gray-200 rounded w-1/4" data-id="element-688"></div>
          </div>
          <div className="flex-1 bg-gray-200 rounded w-full" data-id="element-689"></div>
        </div>
      </div>
    </div>;
};
export default SkeletonChart;